import { createFileRoute, Outlet } from '@tanstack/react-router'
import { DocsLayout } from '../components/docs/DocsLayout'

/**
 * Layout route for /docs. Every docs page renders inside the same shell, so
 * the sidebar keeps its scroll position when moving between pages.
 */
export const Route = createFileRoute('/docs')({
  component: () => (
    <DocsLayout>
      <Outlet />
    </DocsLayout>
  ),
})
